import { isAbUseExperimentActive } from './isAbUseExperimentActive';
import { DAILYRENT_DESKTOP_HYBRID_EXP } from '../../constants/config';
import { TExperimentsState } from '../../types/experiments';

export function isDailyrentDesktopHybridExpActive(experiments: TExperimentsState): boolean {
  return isAbUseExperimentActive(experiments, DAILYRENT_DESKTOP_HYBRID_EXP, 'B');
}
